var map = {
	"./add-user-white.svg": "c084",
	"./add-user.svg": "0bef",
	"./auth-cross.svg": "54cf",
	"./burger-menu.svg": "1bb8",
	"./chevron-blue-right.svg": "7fe1",
	"./cross-gray.svg": "1d28",
	"./download.svg": "9f0f",
	"./hangup.svg": "9967",
	"./hold.svg": "cb5d",
	"./home.svg": "e3e6",
	"./infinity.svg": "60cf",
	"./invoice-blue-bg.svg": "7997",
	"./invoice.svg": "129c",
	"./micro-muted.svg": "b2b0",
	"./micro-small-muted.svg": "fb84",
	"./micro-small.svg": "aec6",
	"./micro-unmuted.svg": "ad00",
	"./micro.svg": "85f1",
	"./ongoing.svg": "976f",
	"./pause.svg": "5546",
	"./pencil.svg": "2d07",
	"./play.svg": "cc2e",
	"./plus-white.svg": "6f8a",
	"./rocket.svg": "1929",
	"./scheduled.svg": "fd11",
	"./settings.svg": "1354",
	"./thumb-up.svg": "5c23",
	"./triangle-gray-down.svg": "337f",
	"./triangle-white-up.svg": "2602"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";